import React from "react";
import Workbook from "react-excel-workbook";
import { Button } from "antd";

export default function DownloadStudent({ isLoading, data, status }) {
  const excelfilename = `${data[0]?.eventName}_${data[0]?.jobTitle}_REPORT.xlsx`;

  const sheetStyles = {
    boldLabels: {
      font: { bold: true },
    },
  };

  return (
    <Workbook
      filename={excelfilename}
      element={
        <>
          <Button
            disabled={isLoading ? true : false}
            loading={isLoading}
            type="primary"
          >
            Download
          </Button>
        </>
      }
    >
      <Workbook.Sheet data={data} name="Students" style={sheetStyles}>
        <Workbook.Column label="JobTitle" value="jobTitle" />
        <Workbook.Column label="Student-Name" value="studentName" />
        <Workbook.Column label="Email" value="studentEmail" />
        <Workbook.Column label="Phone" value="studentPhone" />
        <Workbook.Column label="Employer" value="employerName" />
        <Workbook.Column label="Employer Email" value="employerEmail" />
        <Workbook.Column label="Employer Phone" value="employerPhone" />
        <Workbook.Column label="Job Type" value="jobType" />
        <Workbook.Column label="Status" value="applicationStatus" />
      </Workbook.Sheet>
    </Workbook>
  );
}
